module.exports = __webpack_public_path__ + "img/turab-saygun-logo.92bcb55d.svg";